import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	spinnerLabel: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'language-settings.sidebar-translations.title',
		defaultMessage: 'loading',
		description: 'A11y label for Language settings content loading state spinner.',
	},
});
